/* eslint-disable import/no-anonymous-default-export */
// © Microsoft Corporation. All rights reserved.

import React, { useEffect, useState } from 'react';
import { Stack, Spinner, PrimaryButton } from '@fluentui/react';
import LocalPreview from './LocalPreview';
import LocalSettings from './LocalSettings';
import DisplayNameField from './DisplayNameField';
import {
    VideoDeviceInfo,
    AudioDeviceInfo,
    LocalVideoStream,
    DeviceManager,
    CallAgent,
    CallEndReason,
    Features,
    MediaStatsCollectorOptions,
    CallClient
} from '@azure/communication-calling';
import {
    configurationStackTokens,
    buttonStyle,
    disabledbuttonStyle,
    localSettingsContainerStyle,
    mainContainerStyle,
    fullScreenStyle,
    verticalStackStyle,
    countdownStyle,
    countdownNumberStyle,
    buttonMediaStyle,
    countdownTextStyle,
    localSettingsContainerSecondCameraStyle,
    progressStyle
} from './styles/Configuration.styles';
import { AzureCommunicationTokenCredential } from '@azure/communication-common';
import { ThreadState } from '../core/reducers/ThreadReducers';
import { labelConstants, URLOptionsConstants } from '../core/constants';
import Countdown from 'react-countdown';
import { IsCandidateMode, IsHiddenMode, IsSecondaryStream, GetUsername, GetUsernameLabel, ShouldAutoStart } from 'Utils/Utils';
import { GetSelectedCamera, GetSelectedMicrophone, AddRoundTrip, pingConnectedUser } from '../core/sideEffects';
import { RootStateOrAny, useSelector } from 'react-redux';

export type TokenResponse = {
    tokenCredential: AzureCommunicationTokenCredential;
    userId: string;
};

export interface ConfigurationScreenProps {
    userId: string;
    groupId: string;
    callAgent: CallAgent;
    deviceManager: DeviceManager;
    setupCallClient(unsupportedStateHandler: () => void): void;
    setupCallAgent(
        displayName: string,
        groupId: string,
        afterSetupHandler: (callAgent: CallAgent, groupId: string) => void
    ): void;
    setGroup(groupId: string): void;
    startCallHandler(): void;
    unsupportedStateHandler: () => void;
    callEndedHandler: (reason: CallEndReason) => void;
    videoDeviceList: VideoDeviceInfo[];
    audioDeviceList: AudioDeviceInfo[];
    setVideoDeviceInfo(device: VideoDeviceInfo): void;
    setAudioDeviceInfo(device: AudioDeviceInfo): void;
    mic: boolean;
    setMic(mic: boolean): void;
    setLocalVideoStream(stream: LocalVideoStream | undefined): void;
    localVideoRendererIsBusy: boolean;
    videoDeviceInfo: VideoDeviceInfo;
    audioDeviceInfo: AudioDeviceInfo;
    localVideoStream: LocalVideoStream;
    screenWidth: number;
    joinGroup(callAgent: CallAgent, groupId: string): Promise<void>;
    getToken(): Promise<TokenResponse>;
    Setpropsthreadid(): Promise<void>;
    createCallAgent(tokenCredential: AzureCommunicationTokenCredential, displayName: string, pinName: string, callClient: CallClient): Promise<CallAgent>;
    registerToCallEvents(
        userId: string,
        callAgent: CallAgent,
        endCallHandler: (reason: CallEndReason) => void
    ): Promise<void>;
    thread: ThreadState;
    setup(displayName: string): void;
}
let init: boolean = true;
export default (props: ConfigurationScreenProps): JSX.Element => {
    const spinnerLabel = labelConstants.InitClient;
    const buttonText = labelConstants.StartCall.toString();

    const urlParams = new URLSearchParams(window.location.search.substring(1));

    //const uriusername = IsHiddenMode() || IsProctorMode() ? GetHiddenUsername() : urlParams.get('username') ?? '';
    //const username = IsHiddenMode() || IsProctorMode() ? uriusername : (uriusername === '' ? (IsSecondaryStream() ? GetSecondaryStreamUsername() : 'user' + Math.ceil(Math.random() * 1000)) : (IsSecondaryStream() ? Constants.Secondary_USER_PREFIX + uriusername : uriusername));
    const username = GetUsername();

    const urifullname = urlParams.get('fullname');
    const fullName = urifullname == null || urifullname === '' ? '' : `${urifullname}_`;

    const createUserName = (): string => `${fullName}${username}`;
    const [name, setName] = useState(createUserName());

    const [emptyWarning, setEmptyWarning] = useState(false);
    const { groupId, setupCallClient, setGroup, unsupportedStateHandler } = props;
    const { setup } = props;
    const [startClicked, setStartClicked] = useState(false);
    const autoStartSeconds = IsHiddenMode() || IsSecondaryStream() ? 3 : 15;
    const callClient = useSelector((state: RootStateOrAny) => state.sdk.callClient);
    console.log("UserAgent:-" + window.navigator.userAgent);


    useEffect(() => {
        setupCallClient(unsupportedStateHandler);
    }, [setupCallClient, unsupportedStateHandler]);

    useEffect(() => {
        const threadId = urlParams.get(URLOptionsConstants.THREADID);
        let pingInterval: ReturnType<typeof setInterval> | null = null;
        if (IsCandidateMode() && threadId != null) {
                pingInterval = setInterval(() => {
                pingConnectedUser(props.userId, threadId);
            }, 3000);
        }
        return () => {
            if (pingInterval) {
                clearInterval(pingInterval);
            }
        };
        }, [IsCandidateMode])

    useEffect(() => {
        if (IsCandidateMode()) {
            props.setMic(true);
        }
        else {
            props.setMic(false);
        }
    }, [IsCandidateMode, props.audioDeviceInfo, callClient]);

    useEffect(() => {
        if ((IsCandidateMode() || IsSecondaryStream()) && props.videoDeviceInfo) {
            const stream = new LocalVideoStream(props.videoDeviceInfo);
            props.setLocalVideoStream(stream);
        }
    }, [IsCandidateMode, props.videoDeviceInfo, callClient]);

    const hasAudioDeviceInfo = typeof props.audioDeviceInfo !== 'undefined' ? true : false;
    const hasVideoDeviceInfo = typeof props.videoDeviceInfo !== 'undefined' ? true : false;

    const countdownRenderer = ({ total, seconds, completed }: { total: number, seconds: number, completed: boolean }) => {
        // Render a countdown'
        if (ShouldAutoStart(hasVideoDeviceInfo && hasAudioDeviceInfo) && name) {
            if (completed || startClicked) {
                startCallClick();
                // Render a completed state
                if (IsSecondaryStream()) {
                    return (
                        <div>
                            <span className={countdownTextStyle}>Starting your exam</span>
                            <progress className={progressStyle} max={autoStartSeconds * 1000} value={autoStartSeconds * 1000} />
                        </div>
                    );
                }
                else {
                    return <span className={countdownTextStyle}>Starting...</span>;
                }
            }
            else {
                // Render a countdown
                if (IsSecondaryStream()) {
                    return (
                        <div>
                            <span className={countdownTextStyle}>Starting your exam</span>
                            <progress className={progressStyle} max={autoStartSeconds * 1000} value={autoStartSeconds * 1000 - total} />
                        </div>
                    );
                }
                else {
                    return <span className={countdownStyle}>AutoStart: <span className={countdownNumberStyle}>{seconds}</span> sec</span>
                }
            }
        }
        else { return <span className={countdownStyle}>&nbsp;</span> };
    };

    const startCallClick = async (): Promise<void> => {
        if (!name) {
            setEmptyWarning(true);
        } else if (!startClicked) {
            setStartClicked(true);
            setEmptyWarning(false);
            //1. Retrieve a token
            const { tokenCredential, userId } = await props.getToken();

            let urlparams = window.location.search.substring(1);
            if (urlparams.includes(URLOptionsConstants.USERID)) {
                var url = new URL(window.location.href);
                var search_params = url.searchParams;
                search_params.set(URLOptionsConstants.USERID, userId);
                url.search = search_params.toString();
                window.history.pushState({}, document.title, url.toString());
            }
            else {
                if (urlparams.includes('?') || urlparams.includes('&'))
                    window.history.pushState({}, document.title, window.location.href + '&' + URLOptionsConstants.USERID + '=' + userId);
                else
                    window.history.pushState({}, document.title, window.location.href + '?' + URLOptionsConstants.USERID + '=' + userId);
            }

            //2. Initialize the call agent
            const callAgent = await props.createCallAgent(tokenCredential, name, username, callClient);
            //3. Register for calling events

            await props.registerToCallEvents(userId, callAgent, props.callEndedHandler);

            //4. Create Chat Thread
            //  await props.CreateChatThread();
            await props.Setpropsthreadid();
            //5. add user to the thread
            setup(name);

            //6. Join the call
            await props.joinGroup(callAgent, groupId);

            const mediaStatsFeature = callAgent.calls[0].feature(Features.MediaStats);
            const mediaStatsCollectorOptions: MediaStatsCollectorOptions = {
                aggregationInterval: 10,
                dataPointsPerAggregation: 1
            };
            const mediaStatsCollector = mediaStatsFeature.createCollector(mediaStatsCollectorOptions);

            mediaStatsCollector.on('summaryReported', (summary) => {
                console.log('media stats summary', summary);

                let maxRoundTrip: number[] = []
                if (summary.audio.send.length > 0) {

                    if (summary.audio.send[0].rttInMs?.aggregation?.max[0] != undefined) {
                        maxRoundTrip.push(summary.audio.send[0].rttInMs?.aggregation?.max[0]);
                    }
                }
                if (summary.video.send.length > 0) {

                    if (summary.video.send[0].rttInMs?.aggregation?.max[0] != undefined) {
                        maxRoundTrip.push(summary.video.send[0].rttInMs?.aggregation?.max[0]);
                    }
                }
                if (summary.screenShare.send.length > 0) {

                    if (summary.screenShare.send[0].rttInMs?.aggregation?.max[0] != undefined) {
                        maxRoundTrip.push(summary.screenShare.send[0].rttInMs?.aggregation?.max[0]);
                    }
                }
                if (summary.transports.length > 0) {

                    if (summary.transports[0].rttInMs?.aggregation?.max[0] != undefined) {
                        maxRoundTrip.push(summary.transports[0].rttInMs?.aggregation?.max[0]);
                    }
                }
                AddRoundTrip(Math.max(...maxRoundTrip.map(item => item)));
            });

            props.startCallHandler();
            setGroup(groupId);
        }
    }

    if (init) {

        if (props.videoDeviceList.length > 0) {
            if (props.videoDeviceList.length < GetSelectedCamera()) {
                props.setVideoDeviceInfo(props.videoDeviceList[0]);
            }
            else {
                let i: number = 0;
                props.videoDeviceList.forEach((data) => {
                    if (i === GetSelectedCamera()) {
                        props.setVideoDeviceInfo(data);
                    }
                    i++;
                });
            }
        }

        if (props.audioDeviceList.length > 0) {
            if (props.audioDeviceList.length < GetSelectedMicrophone()) {
                props.setAudioDeviceInfo(props.audioDeviceList[0]);
            }
            else {
                let i: number = 0;
                props.audioDeviceList.forEach((data) => {
                    if (i === GetSelectedMicrophone()) {
                        props.setAudioDeviceInfo(data);
                    }
                    i++;
                });
            }
        }

        init = false;
    }

    return (
        <Stack className={mainContainerStyle} horizontalAlign="center" verticalAlign="center" >
            {props.deviceManager ? (
                <Stack
                    className={props.screenWidth > 750 ? fullScreenStyle : verticalStackStyle}
                    horizontal={props.screenWidth > 750}
                    horizontalAlign="center"
                    verticalAlign="center"
                    tokens={props.screenWidth > 750 ? configurationStackTokens : undefined}
                >
                    <LocalPreview
                        mic={props.mic}
                        setMic={props.setMic}
                        setLocalVideoStream={props.setLocalVideoStream}
                        videoDeviceInfo={props.videoDeviceInfo}
                        audioDeviceInfo={props.audioDeviceInfo}
                        localVideoStream={props.localVideoStream}
                        videoDeviceList={props.videoDeviceList}
                        audioDeviceList={props.audioDeviceList}
                        setAudioDeviceInfo={props.setAudioDeviceInfo}
                        setVideoDeviceInfo={props.setVideoDeviceInfo}
                    />
                    <Stack className={IsSecondaryStream() ? localSettingsContainerSecondCameraStyle : localSettingsContainerStyle}>
                        {!IsSecondaryStream() &&
                            <DisplayNameField setName={setName} name={GetUsernameLabel(name)} setEmptyWarning={setEmptyWarning} isEmpty={emptyWarning} />}
                        <div>
                            <LocalSettings
                                videoDeviceList={props.videoDeviceList}
                                audioDeviceList={props.audioDeviceList}
                                audioDeviceInfo={props.audioDeviceInfo}
                                videoDeviceInfo={props.videoDeviceInfo}
                                setVideoDeviceInfo={props.setVideoDeviceInfo}
                                setAudioDeviceInfo={props.setAudioDeviceInfo}
                                deviceManager={props.deviceManager}
                                setLocalVideoStream={props.setLocalVideoStream}
                            />
                        </div>
                        <div className={buttonMediaStyle} >
                            <Countdown date={Date.now() + autoStartSeconds * 1000} intervalDelay={100} precision={3} renderer={countdownRenderer} />
                            {!IsSecondaryStream() &&
                                <PrimaryButton
                                    className={hasAudioDeviceInfo ? buttonStyle : disabledbuttonStyle}
                                    onClick={startCallClick}
                                    disabled={!hasAudioDeviceInfo}
                                >
                                    {buttonText}
                                </PrimaryButton>
                            }
                        </div>
                    </Stack>
                </Stack>
            ) : (
                <Spinner label={spinnerLabel} ariaLive="assertive" labelPosition="top" />
            )}
        </Stack>
    );
};